import fireErrorAnalytics from '@atlassian/jira-errors-handling/src/utils/fire-error-analytics.tsx';
import { isHttpClientErrorResponse } from '@atlassian/jira-fetch/src/utils/is-error.tsx';
import { performGetRequest } from '@atlassian/jira-fetch/src/utils/requests.tsx';
import type { BoardIssue, IssueTransition } from '../../common/types.tsx';
import { STATUS_ID } from '../../common/constants.tsx';
import type { Response } from './types.tsx';

export const fetchIssueTransitions = async (
	signal: AbortSignal,
	issue: BoardIssue,
): Promise<IssueTransition[]> => {
	try {
		const response = await performGetRequest<Response>(
			`/rest/api/3/issue/${issue.id}/transitions`,
			{
				signal,
			},
		);

		return response.transitions.map((transition) => ({
			transitionId: Number(transition.id),
			name: transition.name,
			isConditional: transition.isConditional,
			isGlobal: transition.isGlobal,
			isInitial: transition.isInitial,
			hasScreen: transition.hasScreen,
			toStatus: {
				id: Number(transition.to.id),
				name: transition.to.name,
				statusCategory: {
					id: transition.to.statusCategory.id,
					name: transition.to.statusCategory.name,
				},
			},
			fromStatus: {
				id: Number(issue.fields[STATUS_ID].status.id),
				statusCategory: {
					id: issue.fields[STATUS_ID].status.statusCategoryId,
				},
				name: issue.fields[STATUS_ID].status.name,
			},
		}));
		// eslint-disable-next-line @typescript-eslint/no-explicit-any
	} catch (error: any) {
		if (!isHttpClientErrorResponse(error) && !signal.aborted) {
			fireErrorAnalytics({
				meta: {
					id: 'fetchIssueTransitions',
					packageName: 'jiraWorkManagementBoard',
					teamName: 'wanjel',
				},
				error,
				sendToPrivacyUnsafeSplunk: true,
			});
		}

		throw error;
	}
};
